// eslint-disable-next-line import/prefer-default-export
export const CLEAN_SALON_RESPONSE_DATA = 'CLEAN_SALON_RESPONSE_DATA';
